"use strict";

exports.__esModule = true;
exports.PluginsList = void 0;
var _maximo = require("./maximo");
var PluginsList = exports.PluginsList = {
  MAXIMO: _maximo.maximo
};